// src/components/DonationModal.jsx
import React from "react";

export default function DonationModal({ open, onClose }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-4 text-gray-400 hover:text-red-500 text-xl"
                >
                    &times;
                </button>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Support Our Work</h2>
                <p className="text-sm text-gray-600 mb-6">
                    Choose a donation method below. Your support helps us continue our mission.
                </p>

                <div className="space-y-4">
                    <div className="border border-gray-200 rounded-lg p-4 hover:shadow">
                        <h3 className="font-semibold text-gray-800 mb-2">Local (Kenya)</h3>
                        <ul className="text-sm text-gray-700 list-disc list-inside">
                            <li><strong>M-PESA Paybill:</strong>Under Development</li>
                            <li><strong>Account Number:</strong>Under Development</li>
                            <li><strong>Airtel Money:</strong>Under Development</li>
                        </ul>
                    </div>

                    <div className="border border-gray-200 rounded-lg p-4 hover:shadow">
                        <h3 className="font-semibold text-gray-800 mb-2">International</h3>
                        <ul className="text-sm text-gray-700 list-disc list-inside">
                            <li><strong>Bank Transfer</strong>Under Development</li>
                                {/* <li>
                                    Bank Transfer (USD):<br />
                                    Account: 000000000<br />
                                    Swift Code: XYZBKENXXX
                                </li>*/}
                            </ul> 
                    </div>
                </div>

                <div className="pt-6 text-right">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-white bg-orange-900 rounded hover:bg-orange-600"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
